import type { TBoard } from '../types';

export function checkDraw(board: TBoard): boolean {
  return board.every((row) => row.every((cell) => cell !== null));
}
